/*
InfiniteScroll
 */
var InfiniteScroll = function(element){
    this.$element = null;
    this.isLoad = false;
    this.point;
}

InfiniteScroll.prototype = {
    set: function($element){
        this.$element = $element;
    },
    checkPosition: function(){
        var $window = $(window);
        var scrollBottom = $window.scrollTop() + window.innerHeight + 1000;
        var linkTop = this.$element.offset().top;
        if(scrollBottom >= linkTop){
            return true;
        }else{
            return false;
        }
    },
    isLoading:　function(){
        return this.isLoad;
    },
    endLoading:　function(){
        this.isLoad = false;
    },
    load: function(callback){
        var self = this;
        if(this.isLoad){
            return;
        }
        var url = this.$element.attr('href');
        if (url == '') {
            $('.loading-icon').parent('div').hide();
            return;
        }

        this.isLoad = true;

        $.ajax({
            type: "GET",
            url: url,
            data: { 'append': 'true' },
        }).done(function( content ) {
            if (window.history && window.history.pushState){
                window.history.pushState('', '', url);
            }

            self.$element.after(content);
            ga('send', 'pageview', location.pathname);
            setTimeout(function() {
                self.set($('body').find('.js-infinite-scroll:last'));
                if(callback){
                    callback();
                }
                self.isLoad = false;
            }, 1000);
        }).fail(function() {
            $('.loading-icon').parent('div').hide();
        });
    }
}

module.exports = InfiniteScroll;



/** WEBPACK FOOTER **
 ** ./src/pc/assets/js/module/InfiniteScroll.js
 **/